import { createCollectionReducer } from "reducers/account/collections";

export default createCollectionReducer("flowStatus");

const selectRoot = state => state.account.flowStatus;
export const selectFlowStatus = (state, id) => selectRoot(state)[id] || {};
